import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import moment from "moment";
import { filter } from "lodash";
import StaffDetails from "./StaffDetails";
import staffImage from "../../files/nurse.png";
import { USERS_ROLE } from "../../constants/role.constant";
const _ = require("lodash");
function fullname(cell, row) {
  const profileImage = row.user && row.user.profileImage ? process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + row.user.profileImage : staffImage;
  return (
    <div className={row.user != undefined && row.user.isActive ? "" : " text-danger"}>
      <span>
        <img src={profileImage} className="mr-2" alt="image" />
        {capitalize(row.lname)} {capitalize(row.fname)}
      </span>
    </div>
  );
}
function capitalize(cell) {
  if (cell) {
    return cell.charAt(0).toUpperCase() + cell.slice(1);
  }
}
function isApproved(cell, row) {
  return (
    <span>
      {cell ? (
        <label className="badge badge-gradient-success">ACCOUNT CREATED</label>
      ) : (
        <label className="badge badge-warning">PENDING INVITATION</label>
      )}
    </span>
  );
}
function formatDate(cell, row) {
  return moment(row.receivedBy.bday).format("MMMM DD, YYYY");
}
function priceFormatter(column, colIndex, { sortElement, filterElement }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span className="mb-2">{filterElement}</span>

      {column.text}
      {sortElement}
    </div>
  );
}
function showButtons(cell, row, rowIndex, formatExtraData) {
  return (
    <div>
      {!row.isCreated && (
        <button
          type="button"
          onClick={() => formatExtraData.delete(row._id)}
          className="btn btn-danger btn-fw"
        >
          Delete Invitation
        </button>
      )}
    </div>
  );
}
const rowComponent = (
  row,
  users,
  expectations,
  userInputChange,
  expectationInputChange,
  ongoingAssignedUsersListsRequest
) => (
  <StaffDetails
    row={row}
    users={users}
    userInputChange={userInputChange}
    expectationInputChange={expectationInputChange}
    expectations={expectations}
    ongoingAssignedUsersListsRequest={ongoingAssignedUsersListsRequest}
  />
);
const StaffList = (props, context) => (
  <BootstrapTable
    wrapperClasses="table-responsive"
    keyField="_id"
    noDataIndication="No Data Found"
    data={props.staff}
    expandRow={{
      renderer: (row) =>
        rowComponent(
          row,
          filter(props.usersOfferedAccess, { isActive: true }),
          props.expectations,
          props.userInputChange,
          props.expectationInputChange,
          props.ongoingAssignedUsersListsRequest
        ),
      onlyOneExpanding: true,
      showExpandColumn: true,
    }}
    filter={filterFactory()}
    columns={[
      {
        dataField: "user._id",
        text: "ID",
        sort: true,

        headerFormatter: priceFormatter,
      },
      {
        dataField: "fname",
        text: "Name",
        formatter: fullname,
        sort: true,
        filter: textFilter(),
        filterValue: (cell, row) => {
          return row.fname + row.lname + row.organization;
        },
        headerFormatter: priceFormatter,
      },
      {
        dataField: "nickname",
        text: "Nickname",
        sort: true,
        formatter: (cell, row) => {
          return (row.user ? (row.user.nickname ? row.user.nickname : "-" ) : "-");
        },
        filter: textFilter(),
        filterValue: (cell, row) => {
          return (row.user ? (row.user.nickname ? row.user.nickname : "-" ) : "-");
        },
        headerFormatter: priceFormatter,          
      },
      {
        dataField: "email",
        text: "Email",
        sort: true,
        filter: textFilter(),
        headerFormatter: priceFormatter,
      },
      {
        dataField: "role",
        text: "Role",
        sort: true,
        filter: textFilter(),
        formatter: (cell, row) => {
          if(row){
            const roleTypeInfo = USERS_ROLE.filter((item) => item.value == row.role);
            return roleTypeInfo[0] ? roleTypeInfo[0].role : row.role;
          }else{
            return "-";
          }
        },
        filterValue: (cell, row) => {
          if(row.user){
            const roleTypeInfo = USERS_ROLE.filter((item) => item.value == row.role);
            return roleTypeInfo[0] ? roleTypeInfo[0].role : row.role;
          }else{
            return "-";
          }
        },
        headerFormatter: priceFormatter,
      },

      {
        dataField: "isCreated",
        text: "Status",
        formatter: isApproved,
        headerFormatter: priceFormatter,
      },
    ]}
  />
);

export default StaffList;
